// src/components/forums/TopicLikesModal.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

interface TopicLikesModalProps {
  isOpen: boolean;
  onClose: () => void;
  likeAvatars: {
    auth_id: string;
    full_name: string;
    avatar_url: string | null;
    city?: string | null;
  }[];
}

const TopicLikesModal: React.FC<TopicLikesModalProps> = ({
  isOpen,
  onClose,
  likeAvatars,
}) => {
  const navigate = useNavigate();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px] bg-dark-200 text-white border-dark-300">
        <DialogHeader>
          <DialogTitle>Members who liked this topic</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          {likeAvatars.length > 0 ? (
            <ul className="space-y-3">
              {likeAvatars.map((user) => (
                <li
                  key={user.auth_id}
                  className="flex items-center space-x-3 p-2 rounded-lg hover:bg-dark-300 transition-colors"
                >
                  <img
                    src={
                      user.avatar_url ||
                      'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/gold_symbol-removebg-n5agUlyNamyXXN0FU8QGzScjug8DVS.png'
                    }
                    alt={user.full_name}
                    className="w-10 h-10 rounded-full object-cover border border-dark-400"
                  />
                  <div className="flex-1">
                    <button
                      onClick={() => {
                        navigate(`/dashboard/members/${user.auth_id}`);
                        onClose();
                      }}
                      className="text-white font-medium hover:text-gold-400 transition-colors text-left"
                    >
                      {user.full_name}
                    </button>
                    {user.city && (
                      <div className="text-xs text-dark-800">{user.city}</div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-dark-800 text-center py-4">No likes yet.</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TopicLikesModal;
